export const DIVIDER_HEIGHT = '0.063rem'
export const NAVIGATION_HEIGHT = '4rem'
export const LONDON_TIMEZONE = 'Europe/London'
export const ONE_DAY = 24 * 60 * 60 * 1000
export const INDEXING_OFFSET = 1 /* Cols in grid 1-indexed */

export const TIMELINE_TRACK_HEIGHT = '3.438rem'
